import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
 import axios from '../../redux/axios';

const initialState = {
  office: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const addOfficeAsyn = createAsyncThunk(
  'department/addOffice',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/department/addDeptType',udata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const addOfficeSlice = createSlice({
  name: 'addoffice',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSlice: (state, {payload}) => { 
       state.office = [];
       state.isError = false;
       state.isSuccess = false;
       state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
        [addOfficeAsyn.fulfilled]: (state, { payload }) => {
          state.office = payload.data;
          state.isFetching = false;
          state.isSuccess = true;
          state.errorMessage = payload.message;
          return state;
        },
        [addOfficeAsyn.pending]: (state) => {
          state.isFetching = true;
        },
        [addOfficeAsyn.rejected]: (state, { payload }) => {
          state.isFetching = false;
          state.isError = true;
          if(payload){
            state.errorMessage = payload.message;
          }
          else{
            state.errorMessage = 'Internal error';
          }
        }
    },
});

 export const {clearStateSlice} = addOfficeSlice.actions;

 export function clearState() {
  
  return async (dispatch) => {
    dispatch(clearStateSlice());
  }
}

export const addOfficeSelector = (state) => state.addoffice;

export default addOfficeSlice.reducer;
